import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'cccisd-loader';
import useQuery from '../../../useQuery.js';
import calloutsQuery from './calloutsQuery.graphql';
import Callout from './components/Callout';
import _mean from 'lodash/mean';
import _round from 'lodash/round';
import style from './style.css';

const Component = props => {
    const { show } = props.settings;
    const { isPreview, query } = props;

    const [data, loading] = useQuery({
        query: isPreview ? calloutsQuery : query,
        variables: props.filters,
    });

    if (loading) {
        return <Loader loading />;
    }

    const calloutsData = props.convertDataStructure(data);

    // console.log(calloutsData);

    const {
        overallFidelity,
        targetFidelity,
        sessionsMetBenchmark,
        totalSessions,
        highestFidelitySession,
        lowestFidelitySession,
    } = calloutsData;

    return (
        <>
            {show && (
                <div className={style.callouts}>
                    {props.settings.overallFidelity.show && (
                        <Callout
                            handle="overallValue"
                            settings={{
                                ...props.settings.overallFidelity,
                                colors: props.settings.colors,
                            }}
                            data={{ overallFidelity, targetFidelity }}
                        />
                    )}
                    {props.settings.benchmark.show && (
                        <Callout
                            handle="benchmark"
                            settings={{
                                ...props.settings.benchmark,
                                colors: props.settings.colors,
                            }}
                            data={{ sessionsMetBenchmark, totalSessions }}
                        />
                    )}
                    {props.settings.bySession.show && (
                        <Callout
                            handle="bySession"
                            settings={{
                                ...props.settings.bySession,
                                colors: props.settings.colors,
                            }}
                            data={{ highestFidelitySession, lowestFidelitySession }}
                        />
                    )}
                </div>
            )}
        </>
    );
};

Component.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
};

Component.defaultProps = {
    filters: {},
    convertDataStructure: data => {
        // console.log(data);
        let convertedData = {};

        if (data && data.groups.treatmentGroupList.length > 0) {
            const getScoresBySession = () => {
                let sessionScores = [[], [], [], [], []];

                data.groups.treatmentGroupList.forEach(tg => {
                    for (let i = 0; i < 5; i++) {
                        const averageSessionFidelity =
                            tg.childRoles.metricspawn[`session${i + 1}`].devTags.FidelityChecklistScore;
                        if (averageSessionFidelity !== null) {
                            sessionScores[i].push(Number(averageSessionFidelity));
                        }
                    }
                });
                const avgScores = sessionScores.map(s => _mean(s));
                return avgScores;
            };

            const _findLargestNumber = numberList => {
                let highest = 0;
                let highestPos = 0;
                for (let i = 0; i < numberList.length; i++) {
                    if (!Number.isNaN(numberList[i])) {
                        if (numberList[i] > highest) {
                            highest = numberList[i];
                            highestPos = i;
                        }
                    }
                }
                return highestPos;
            };

            const _findSmallestNumber = numberList => {
                let lowest = 6;
                let lowestPos = 0;
                for (let i = 0; i < numberList.length; i++) {
                    if (!Number.isNaN(numberList[i])) {
                        if (numberList[i] < lowest) {
                            lowest = numberList[i];
                            lowestPos = i;
                        }
                    }
                }
                return lowestPos;
            };

            const scoresBySession = getScoresBySession();

            convertedData = {
                overallFidelity: _round(_mean(scoresBySession.filter(Boolean)), 1),
                targetFidelity: 4,
                sessionsMetBenchmark: 60,
                totalSessions: 80,
                highestFidelitySession: _findLargestNumber(scoresBySession) + 1,
                lowestFidelitySession: _findSmallestNumber(scoresBySession) + 1,
            };
        } else {
            convertedData = {
                overallFidelity: 4,
                targetFidelity: 4,
                sessionsMetBenchmark: 60,
                totalSessions: 80,
                highestFidelitySession: 4,
                lowestFidelitySession: 1,
            };
        }
        // console.log({ convertedData });
        return convertedData;
    },
};

export default Component;
